/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//window._theme=window._theme||{},_theme.Helpers=function(){function e(e,t,r){var c="";if(r){var i=new Date;i.setTime(i.getTime()+24*r*60*60*1e3),c="; expires="+i.toUTCString()}document.cookie=e+"="+(t||"")+c+"; path=/"}function t(e){for(var t=e+"=",r=document.cookie.split(";"),c=0;c<r.length;c++){for(var i=r[c];" "==i.charAt(0);)i=i.substring(1,i.length);if(0==i.indexOf(t))return i.substring(t.length,i.length)}return null}function r(e){document.cookie=e+"=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"}return{setCookie:e,getCookie:t,eraseCookie:r}}(),_theme.TransyCurrencySwitcher=function(){function e(){this.container=document.querySelectorAll(t.container),window._transcy&&this.container&&0!==this.container.length&&(r.flagBaseURL=window._transcy.variants.currencyFlagUrl||r.flagBaseURL,this.currencies=window._transcy.variants.currencies,this.currencies&&0!==this.currencies.length&&this.init())}var t={container:".cr_dropdown",cr_selected:".cr_dropdown_selected",cr_flag:".cr_flag",cr_label:".cr_label",cr_item_wrapper:".cr_list ul",cr_item:".cr_list ul .cr_item",cr_cta:".cr_cta button",header_cr:".desktop-currency .cr-header",header_cr_label:".desktop-currency .Heading span",cr_modal:".cr-modal"},r={flagBaseURL:"https://app.transcy.io/currency_flags/",item_html:'<li data-code="{{flagCode}}" class="cr_item"><img class="cr_flag" alt="transcy-flag" src="{{flagURL}}" width="22" height="16"><span class="cr_label">{{flagCode}}</span></li>'};return e.prototype.init=function(){var e=this,r=_theme.Helpers.getCookie("cr");if(!r){var c=document.querySelector(t.cr_modal);c&&c.classList.remove("hideme")}this.cr_selected=document.querySelectorAll(t.cr_selected),this.cr_cta=document.querySelectorAll(t.cr_cta),this.header_cr=document.querySelector(t.header_cr),this.cr_item_wrapper=document.querySelectorAll(t.cr_item_wrapper),this.setCurrentCurrency(window._transcy.variants.currencyCurrent),this.setCurrencies(),this.cr_items=document.querySelectorAll(t.cr_item),this.header_cr.addEventListener("click",function(e){e.preventDefault(),e.currentTarget.parentElement.querySelector(t.container).classList.toggle("open")}),this.cr_selected.forEach(function(e){e.addEventListener("click",function(){this.closest(".cr_list").classList.toggle("open")})}),this.cr_items.forEach(function(t){t.addEventListener("click",function(t){var r=this.dataset.code;r&&e.setCurrentCurrency(r,t)})},this),this.cr_cta.forEach(function(r){r.addEventListener("click",function(r){window._transcy.methods.changeCurrency(e.current_currency_code),r.target.closest(t.container).classList.remove("open"),_theme.Helpers.setCookie("cr",e.current_currency_code,90)})})},e.prototype.buildItemHtml=function(e){var t=r.item_html,c=r.flagBaseURL+""+e+".png";return t=t.replace("{{flagURL}}",c),t=t.replace("{{flagCode}}",e),t=t.replace("{{flagCode}}",e),{item_html:t,flag_url:c,code:e}},e.prototype.setCurrentCurrency=function(e,r){var c=this.buildItemHtml(e);this.cr_selected.forEach(function(r){r.querySelector(t.cr_flag).src=c.flag_url,r.querySelector(t.cr_label).innerHTML=e}),document.querySelector(t.header_cr_label).innerHTML=e,this.current_currency_code=e,r&&r.target.closest(".cr_list").classList.remove("open")},e.prototype.setCurrencies=function(){var e="";this.currencies.forEach(function(t){var r=this.buildItemHtml(t.code);e+=r.item_html},this),this.cr_item_wrapper.forEach(function(t){t.innerHTML=e})},e}(),_theme.Wishlist=function(){function e(){var e=JSON.parse(localStorage.getItem("iWishlistmain"));if(e&&$(".iWishAdd").length)for(item in e)if(item&&""!=item){var t=e[item];$(".iWishAdd").each(function(e){var r=this,c=this.dataset.vid;Array.isArray(t)?t.map(function(e){c&&c==e&&($(r).addClass("iwishAdded"),$(r).text("Added in Wishlist"))}):c&&c==t&&($(this).addClass("iwishAdded"),$(this).text("Added in Wishlist"))})}}function t(){$(document).on("click",".iWishAdd",function(e){if(e.preventDefault(),!$(this).hasClass("iwishAdded")){var t=$(this).data("vid");iwish_add($(this),t),window.syncWithServer&&window.syncWithServer()}})}return{updateWishlistCTALabel:e,wishlistEvent:t}}(),_theme.init=function(){_theme.Wishlist.wishlistEvent()},window.onload=function(){window.syncWithServer&&window.syncWithServer(),new _theme.TransyCurrencySwitcher};
//window._theme=window._theme||{},_theme.Helpers=function(){function e(e,t,r){var c="";if(r){var i=new Date;i.setTime(i.getTime()+24*r*60*60*1e3),c="; expires="+i.toUTCString()}document.cookie=e+"="+(t||"")+c+"; path=/"}function t(e){for(var t=e+"=",r=document.cookie.split(";"),c=0;c<r.length;c++){for(var i=r[c];" "==i.charAt(0);)i=i.substring(1,i.length);if(0==i.indexOf(t))return i.substring(t.length,i.length)}return null}function r(e){document.cookie=e+"=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"}return{setCookie:e,getCookie:t,eraseCookie:r}}(),_theme.TransyCurrencySwitcher=function(){function e(){this.container=document.querySelectorAll(t.container),window._transcy&&this.container&&0!==this.container.length&&(r.flagBaseURL=window._transcy.variants.currencyFlagUrl||r.flagBaseURL,this.currencies=window._transcy.variants.currencies,this.currencies&&0!==this.currencies.length&&this.init())}var t={container:".cr_dropdown",cr_selected:".cr_dropdown_selected",cr_flag:".cr_flag",cr_label:".cr_label",cr_item_wrapper:".cr_list ul",cr_item:".cr_list ul .cr_item",cr_cta:".cr_cta button",header_cr:".desktop-currency .cr-header",header_cr_label:".desktop-currency .Heading span",cr_modal:".cr-modal"},r={flagBaseURL:"https://app.transcy.io/currency_flags/",item_html:'<li data-code="{{flagCode}}" class="cr_item"><img class="cr_flag" alt="transcy-flag" src="{{flagURL}}" width="22" height="16"><span class="cr_label">{{flagCode}}</span></li>'};return e.prototype.init=function(){var e=this,r=_theme.Helpers.getCookie("cr");if(!r){var c=document.querySelector(t.cr_modal);c&&c.classList.remove("hideme")}this.cr_selected=document.querySelectorAll(t.cr_selected),this.cr_cta=document.querySelectorAll(t.cr_cta),this.header_cr=document.querySelector(t.header_cr),this.cr_item_wrapper=document.querySelectorAll(t.cr_item_wrapper),this.setCurrentCurrency(window._transcy.variants.currencyCurrent),this.setCurrencies(),this.cr_items=document.querySelectorAll(t.cr_item),this.header_cr.addEventListener("click",function(e){e.preventDefault(),e.currentTarget.parentElement.querySelector(t.container).classList.toggle("open")}),this.cr_selected.forEach(function(e){e.addEventListener("click",function(){this.closest(".cr_list").classList.toggle("open")})}),this.cr_items.forEach(function(t){t.addEventListener("click",function(t){var r=this.dataset.code;r&&e.setCurrentCurrency(r,t)})},this),this.cr_cta.forEach(function(r){r.addEventListener("click",function(r){window._transcy.methods.changeCurrency(e.current_currency_code),r.target.closest(t.container).classList.remove("open"),_theme.Helpers.setCookie("cr",e.current_currency_code,90)})})},e.prototype.buildItemHtml=function(e){var t=r.item_html,c=r.flagBaseURL+""+e+".png";return t=t.replace("{{flagURL}}",c),t=t.replace("{{flagCode}}",e),t=t.replace("{{flagCode}}",e),{item_html:t,flag_url:c,code:e}},e.prototype.setCurrentCurrency=function(e,r){var c=this.buildItemHtml(e);this.cr_selected.forEach(function(r){r.querySelector(t.cr_flag).src=c.flag_url,r.querySelector(t.cr_label).innerHTML=e}),document.querySelector(t.header_cr_label).innerHTML=e,this.current_currency_code=e,r&&r.target.closest(".cr_list").classList.remove("open")},e.prototype.setCurrencies=function(){var e="";this.currencies.forEach(function(t){var r=this.buildItemHtml(t.code);e+=r.item_html},this),this.cr_item_wrapper.forEach(function(t){t.innerHTML=e})},e}(),_theme.Wishlist=function(){function e(){var e=JSON.parse(localStorage.getItem("iWishlistmain"));if(e&&$(".iWishAdd").length)for(item in e)if(item&&""!=item){var t=e[item];$(".iWishAdd").each(function(e){var r=this,c=this.dataset.vid;Array.isArray(t)?t.map(function(e){c&&c==e&&($(r).addClass("iwishAdded"),$(r).text("Added in Wishlist"))}):c&&c==t&&($(this).addClass("iwishAdded"),$(this).text("Added in Wishlist"))})}}function t(){$(document).on("click",".iWishAdd",function(e){if(e.preventDefault(),!$(this).hasClass("iwishAdded")){var t=$(this).data("vid");iwish_add($(this),t)/*,window.syncWithServer&&window.syncWithServer()*/}})}return{updateWishlistCTALabel:e,wishlistEvent:t}}(),_theme.init=function(){_theme.Wishlist.wishlistEvent()},window.onload=function(){/*window.syncWithServer&&window.syncWithServer(),*/new _theme.TransyCurrencySwitcher};

window._theme = window._theme || {}, _theme.Helpers = function() {
  function e(e, t, r) {
      var c = "";
      if (r) {
          var i = new Date;
          i.setTime(i.getTime() + 24 * r * 60 * 60 * 1e3), c = "; expires=" + i.toUTCString()
      }
      document.cookie = e + "=" + (t || "") + c + "; path=/"
  }

  function t(e) {
      for (var t = e + "=", r = document.cookie.split(";"), c = 0; c < r.length; c++) {
          for (var i = r[c];
              " " == i.charAt(0);) i = i.substring(1, i.length);
          if (0 == i.indexOf(t)) return i.substring(t.length, i.length)
      }
      return null
  }

  function r(e) {
      document.cookie = e + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"
  }
  return {
      setCookie: e,
      getCookie: t,
      eraseCookie: r
  }
}(), 

_theme.TransyCurrencySwitcher = function() {
  var t = {
          container: ".cr_dropdown",
          cr_selected: ".cr_dropdown_selected",
          cr_flag: ".cr_flag",
          cr_label: ".cr_label",
          cr_item_wrapper: ".cr_list ul",
          cr_item: ".cr_list ul .cr_item",
          cr_cta: ".cr_cta button",
          header_cr: ".desktop-currency .cr-header",
          header_cr_label: ".desktop-currency .Heading span",
          cr_modal: ".cr-modal"
    };
    var r = {
          flagBaseURL: "https://app.transcy.io/flags/",
          item_html: '<li data-code="{{flagCode}}" data-flag="{{flagShortCode}}" class="cr_item"><img class="cr_flag" alt="transcy-flag" src="{{flagURL}}" width="22" height="16"><span class="cr_label">{{flagCode}}</span></li>'
    };

  function e() {
      this.container = document.querySelectorAll(t.container);
      if(window._transcy && this.container && 0 !== this.container.length){
          r.flagBaseURL = window._transcy.variants.currencyFlagUrl || r.flagBaseURL;
          this.currencies = window._transcy.variants.listCurrenciesActive;
          if(this.currencies && 0 !== this.currencies.length){
            this.init();
          }
      }
  }
  
  return e.prototype.init = function() {
      var e = this,
          r = _theme.Helpers.getCookie("cr");
      if (!r) {
          var c = document.querySelector(t.cr_modal);
          c && c.classList.remove("hideme")
      }
      this.cr_selected = document.querySelectorAll(t.cr_selected), 
      this.cr_cta = document.querySelectorAll(t.cr_cta), 
      this.header_cr = document.querySelector(t.header_cr), 
      this.cr_item_wrapper = document.querySelectorAll(t.cr_item_wrapper);
    	
    var current_cr = window._transcy.variants.listCurrenciesActive.filter(function(c){
      return c.code === window._transcy.variants.currencyCurrent;
    })[0];
    
      this.setCurrentCurrency({
        code: current_cr.detail.code,
        flag_code: current_cr.detail.flag_code
      }), 
      this.setCurrencies(), this.cr_items = document.querySelectorAll(t.cr_item), 

      this.header_cr.addEventListener("click", function(e) {
          e.preventDefault(), e.currentTarget.parentElement.querySelector(t.container).classList.toggle("open")
      }), 
      
      this.cr_selected.forEach(function(e) {
          e.addEventListener("click", function(ev) {
              ev.preventDefault()
              this.closest(".cr_list").classList.toggle("open")
          })
      }), 
      
      this.cr_items.forEach(function(t) {
          t.addEventListener("click", function(t) {
              var r = this.dataset.code;
              var f_c = this.dataset.flag;
              r && e.setCurrentCurrency({code: r,flag_code: f_c}, t)
          })
      }, this), 
      
      this.cr_cta.forEach(function(r) {
          r.addEventListener("click", function(r) {
            var currency_c = this.closest('.cr_dropdown').querySelector('.cr_dropdown_selected');
            if(currency_c){
              window._transcy.methods.onSelect(currency_c, 'currency');
              r.target.closest(t.container).classList.remove("open"), _theme.Helpers.setCookie("cr", e.current_currency_code, 90)
            }
            //window._transcy.methods.changeCurrency(e.current_currency_code), r.target.closest(t.container).classList.remove("open"), _theme.Helpers.setCookie("cr", e.current_currency_code, 90)
          })
      })
  }, e.prototype.buildItemHtml = function(e) {
      var t = r.item_html,
          c = r.flagBaseURL + "" + e.flag_code + ".svg";
      return t = t.replace("{{flagURL}}", c), t = t.replace("{{flagShortCode}}", e.flag_code), t = t.replace("{{flagCode}}", e.code), t = t.replace("{{flagCode}}", e.code), {
          item_html: t,
          flag_url: c,
          code: e.code
        
      }
  }, e.prototype.setCurrentCurrency = function(e, r) {
      var c = this.buildItemHtml(e);
      this.cr_selected.forEach(function(r) {
          r.setAttribute('data-code', e.code);
          r.setAttribute('data-flag', e.flag_code);
          r.querySelector(t.cr_flag).src = c.flag_url, r.querySelector(t.cr_label).innerHTML = e.code
      });
      document.querySelector(t.header_cr_label).innerHTML = e.code;
      this.current_currency_code = e.code; 
      r && r.target.closest(".cr_list").classList.remove("open");
      if(window.innerWidth < 768 && r) r.target.closest('.cr_dropdown').querySelector('.cr_cta button').click();
  }, e.prototype.setCurrencies = function() {
      var e = "";
      this.currencies.forEach(function(t) {
          var r = this.buildItemHtml({
            code: t.detail.code,
            flag_code: t.detail.flag_code
          });
          e += r.item_html
      }, this), this.cr_item_wrapper.forEach(function(t) {
          t.innerHTML = e
      })
  }, e
}(), 

_theme.Wishlist = function() {
  function e() {
      var e = JSON.parse(localStorage.getItem("iWishlistmain"));
      if (e && $(".iWishAdd").length)
          for (item in e)
              if (item && "" != item) {
                  var t = e[item];
                  $(".iWishAdd").each(function(e) {
                      var r = this,
                          c = this.dataset.vid;
                      Array.isArray(t) ? t.map(function(e) {
                          c && c == e && ($(r).addClass("iwishAdded"), $(r).text("Added in Wishlist"))
                      }) : c && c == t && ($(this).addClass("iwishAdded"), $(this).text("Added in Wishlist"))
                  })
              }
  }

  function t() {
      $(document).on("click", ".iWishAdd", function(e) {
          if (e.preventDefault(), !$(this).hasClass("iwishAdded")) {
              var t = $(this).data("vid");
              iwish_add($(this), t) /*,window.syncWithServer&&window.syncWithServer()*/
          }
      })
  }
  return {
      updateWishlistCTALabel: e,
      wishlistEvent: t
  }
}(), 

//_theme.bsl=function(){function e(){var e=document.querySelector("body.template-collection"),t=document.querySelector("body.template-product");if(_theme.products&&_theme.products.length&&(e&&_theme.products.map(function(e){document.querySelectorAll(".product--"+e.id).forEach(function(e,t){var o=e.querySelector(".ProductItem__LabelList");if(o&&!o.querySelector(".label--bestseller")){if(t) {o.textContent = "Best Seller"} else { var c=document.createElement("span");c.className="label--bestseller ProductItem__Label ProductItem__Label--custom Heading Text--subdued",c.textContent="Best Seller",o.appendChild(c)}}})}),t)){var o=document.querySelector(".Product .Product__LabelList[data-pid]");if(!o)return;var c=o.dataset.pid;if(_theme.products.filter(function(e){return e.id==c})[0]){var l=document.createElement("span");l.className="label--bestseller ProductItem__Label ProductItem__Label--custom Heading Text--subdued",l.textContent="Best Seller",o.appendChild(l)}}}return{fetchProducts:function(){fetch("/collections/all?sort_by=best-selling&view=json").then(function(e){return e.json()}).then(function(t){t.products&&t.products.length&&(_theme.products=t.products,e())}).catch(function(e){console.log(e)})},addBestSellingLabel:e}}();
_theme.bsl = function() {
    function e() {
        var e = document.querySelector("body.template-collection"),
            t = document.querySelector("body.template-product");
        if (_theme.products && _theme.products.length && (e && _theme.products.map(function(e) {
                document.querySelectorAll(".product--" + e.id).forEach(function(e, t) {
                    var o = e.querySelector(".ProductItem__LabelList");
                    if (o && !o.querySelector(".label--bestseller")) {
                        var c = document.createElement("span");
                        c.className = "label--bestseller ProductItem__Label ProductItem__Label--custom Heading Text--subdued", c.textContent = "Best Seller", o.appendChild(c)
                    }
                })
            }), t)) {
            var o = document.querySelector(".Product .Product__LabelList[data-pid]");
            if (!o) return;
            var c = o.dataset.pid;
            if (_theme.products.filter(function(e) {
                    return e.id == c
                })[0]) {
				if(t){
					o.textContent = "Best Seller"
				} else {
					var l = document.createElement("span");
					l.className = "label--bestseller ProductItem__Label ProductItem__Label--custom Heading Text--subdued", l.textContent = "Best Seller", o.appendChild(l)
				}
            }
        }
    }
    return {
        fetchProducts: function() {
            fetch("/collections/all?sort_by=best-selling&view=json").then(function(e) {
                return e.json()
            }).then(function(t) {
                t.products && t.products.length && (_theme.products = t.products, e())
            }).catch(function(e) {
                console.log(e)
            })
        },
        addBestSellingLabel: e
    }
}();

_theme.init = function() {
  _theme.Wishlist.wishlistEvent()
}, 
window.onload = function() {
  /*window.syncWithServer&&window.syncWithServer(),*/
  setTimeout(function(){
    new _theme.TransyCurrencySwitcher
  }, 1000);
};

$(document).ready(function() {
    _theme.init();
    _theme.bsl.fetchProducts();
  
    $('.home_slider').flickity({
        // options
        cellAlign: 'left',
        pageDots: true,
        prevNextButtons: true,
        freeScroll: false,
        wrapAround: true,
        imagesLoaded: true
    });
  
  $('.ctm_meter_plus').on('click',function(e){
    var qty_text = $(this).closest('.ctm_div_wrapper').find('.QuantitySelector__CurrentQuantity').val()
    qty_text = parseFloat(qty_text.split(' ')[0]);
    var compare_qty = parseFloat($(this).closest('form').find('.meter-stock').attr('data-qty'));
    console.log(qty_text,compare_qty,$(this).closest('form').find('.meter-stock').attr('data-qty'));
    if(qty_text < compare_qty){
      $(this).removeClass('btn_disabled');
      $(this).closest('.ctm_div_wrapper').find('.QuantitySelector__CurrentQuantity').val((qty_text+0.5));
      $(this).closest('.ProductForm__QuantitySelector').find('.ctm_trigger [data-action="increase-quantity"]').trigger('click');
      var qty = parseInt($(this).closest('.ProductForm__QuantitySelector').find('.ctm_trigger .QuantitySelector__CurrentQuantity').val());
      var price = 0;
      console.log("qtyvalue- " + qty/2);
      var qtyvalue = qty/2; 
      $(".propertiesQty").attr("value", qtyvalue);
      if($(this).closest('form').find('.ProductForm__Option select').length != 0){
        $(this).closest('form').find('.ProductForm__Option select option').each(function(e){
          if($(this).prop('selected')){
            price = $(this).data('price');
          }
        })
      }else{
        price = $(this).closest('form').find('.ProductForm__Variants [name="id"]').data('price');
      }
      var final_price = qty * price;
      console.log(qty_text,compare_qty);
      if((qty_text+0.5) == compare_qty){
       $(this).addClass('btn_disabled'); 
      }
      var _price = window.__WEBPACK_IMPORTED_MODULE_4__helper_Currency.formatMoney(final_price, window.theme.moneyFormat);
      console.log(_price)
      $('.ProductForm__AddToCart > span:nth-child(3)').html(_price) 
    }else{
      $(this).addClass('btn_disabled');
    }
  })

  $('.ctm_meter_minus').on('click',function(e){
    var qty_text = $(this).closest('.ctm_div_wrapper').find('.QuantitySelector__CurrentQuantity').val();
    $(this).closest('form').find('.ctm_meter_plus').removeClass('btn_disabled');
    qty_text = parseFloat(qty_text.split(' ')[0]);
    var min = $(this).data('min');
    if(min >= 6){
      console.log(qty_text,min);
      if(qty_text <= 3){
        $(this).closest('.ctm_div_wrapper').find('.QuantitySelector__CurrentQuantity').val('3');
        // $(this).closest('.ProductForm__QuantitySelector').find('.ctm_trigger [data-action="decrease-quantity"]').trigger('click');
      }else{
        $(this).closest('.ctm_div_wrapper').find('.QuantitySelector__CurrentQuantity').val((qty_text-0.5));
        $(this).closest('.ProductForm__QuantitySelector').find('.ctm_trigger [data-action="decrease-quantity"]').trigger('click');
      }
    }else{  
      console.log(qty_text,'test');
      if(min > 2){
        if(qty_text <= 1){
        $(this).closest('.ctm_div_wrapper').find('.QuantitySelector__CurrentQuantity').val('1');
          // $(this).closest('.ProductForm__QuantitySelector').find('.ctm_trigger [data-action="decrease-quantity"]').trigger('click');
        }else{
         if(qty_text < 3){
          $(this).closest('.ctm_div_wrapper').find('.QuantitySelector__CurrentQuantity').val((qty_text));
          var qty = qty_text*2; 
          $(this).closest('.ProductForm__QuantitySelector').find('.ctm_trigger [name="quantity"]').val(qty); 
         }else{
           $(this).closest('.ctm_div_wrapper').find('.QuantitySelector__CurrentQuantity').val((qty_text-0.5));
           $(this).closest('.ProductForm__QuantitySelector').find('.ctm_trigger [data-action="decrease-quantity"]').trigger('click'); 
         } 
        }
      }else{
        if(qty_text <= 0.5){
         $(this).closest('.ctm_div_wrapper').find('.QuantitySelector__CurrentQuantity').val('0.5');
         $(this).closest('.ProductForm__QuantitySelector').find('.ctm_trigger [data-action="decrease-quantity"]').trigger('click');
        }else{
          $(this).closest('.ctm_div_wrapper').find('.QuantitySelector__CurrentQuantity').val((qty_text-0.5));
          $(this).closest('.ProductForm__QuantitySelector').find('.ctm_trigger [data-action="decrease-quantity"]').trigger('click');
        }
      }
    }
    
    
    var qty = parseInt($(this).closest('.ProductForm__QuantitySelector').find('.ctm_trigger .QuantitySelector__CurrentQuantity').val());
    console.log("qtyvalue- " + qty/2);
    var qtyvalue = qty/2; 
     $(".propertiesQty").attr("value", qtyvalue);
    var price = 0;
    if($(this).closest('form').find('.ProductForm__Option select').length != 0){
      $(this).closest('form').find('.ProductForm__Option select option').each(function(e){
        if($(this).prop('selected')){
          price = $(this).data('price');
        }
      })
    }else{
      price = $(this).closest('form').find('.ProductForm__Variants [name="id"]').data('price');
    }
    console.log(price,qty,'321465')
    var final_price = qty * price
    var _price = window.__WEBPACK_IMPORTED_MODULE_4__helper_Currency.formatMoney(final_price, window.theme.moneyFormat);
    $('.ProductForm__AddToCart > span:nth-child(3)').html(_price);
  });
  
  $('.find-size-submit').on('click',function(e){
    e.preventDefault();
    $('.recommended-findsize').show();
    var checked = $(this).closest('.find_size_content').find('.biba-radio :radio').prop('checked');
    if(checked){
      $('.recommended-findsize').show();
      var value = $('.biba-size-swatch .active_swatch').next('li').data('val');
      if($('.biba-size-swatch .active_swatch').hasClass('last_value')){
        var val = $('.biba-size-swatch .active_swatch').data('val');
        console.log(val,'demo 456 123')
        $('.recommended-findsize').text('Your recommended Size is '+ val);
      }else{
        $('.recommended-findsize').text('Your recommended Size is '+ value);
      }
    }else{
      value = $('.master_size_value').val();
      console.log(value);
      if(value != ''){
        $('.recommended-findsize').text('Your recommended Size is '+ value);
        $('.recommended-findsize').show();
      }else{
        $('.recommended-findsize').hide();
      }
    }
    return false;
  })
  
  $('.biba-size-swatch li').on('click',function(e){
    $(this).closest('ul').find('.active_swatch').removeClass('active_swatch')
    $(this).addClass('active_swatch');
  })

  
  jQuery('.bra-size select:not(.master_size_value)').change(function() {
    var final_val;
    jQuery('.bra-size select:not(.master_size_value)').each(function(i,e){
      if(i == 0){
        final_val = $(this).val();
        console.log($(this).val());
      }else{
        final_val = final_val+' / '+$(this).val();
      }
    });
    var count = 0;
    jQuery('select.master_size_value option').each(function(i,e){
      if(jQuery(this).data('title') != ''){
        var text = jQuery(this).data('title').trim();
        if(text === final_val){
          var val = $(this).val();
          $(this).prop('selected',true);
          jQuery('select.master_size_value').val(val).trigger('change');
          console.log(val);
          count++;
          return false;
        }
      }
    });
    if(count == 0){
      jQuery('select.master_size_value').val('').trigger('change');
    }
  });

  if($(window).width() < 767){
    var height_header = $('#shopify-section-header').outerHeight();
    var height_annoucement = $('#section-announcement').outerHeight();
    var total_height = height_header + height_annoucement+'px';
    $('#sidebar-menu .Drawer__Content').attr('style','max-height: calc(100vh - '+total_height+');height: calc(100vh - '+total_height+')');
  }
  
});

$(window).on('resize',function(e){
  if($(window).width() < 767){
    var height_header = $('#shopify-section-header').outerHeight();
    var height_annoucement = $('#section-announcement').outerHeight();
    var total_height = height_header + height_annoucement+'px';
    $('#sidebar-menu .Drawer__Content').attr('style','max-height: calc(100vh - '+total_height+');height: calc(100vh - '+total_height+')');
  }
})

$(document).ready(function() {
    $('.home_slider2').flickity({
        // options
        cellAlign: 'left',
        pageDots: true,
        prevNextButtons: true,
        freeScroll: false,
        wrapAround: true
      
    });
});

$(document).ready(function() {
    $('.brand-slider').flickity({
        // options
        cellAlign: 'left',
        pageDots: true,
        prevNextButtons: false,
        freeScroll: false,
        wrapAround: true
    });
});


$(document).ready(function() {
    $('.offer-slider').flickity({
        // options
        cellAlign: 'left',
        pageDots: true,
        prevNextButtons: false,
      adaptiveHeight: true,
          autoPlay: true,
        freeScroll: false,
        wrapAround: true
    });
});

$(document).ready(function() {
    $('.events-flickity').flickity({
        // options
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
      adaptiveHeight: true,
          autoPlay: true,
          autoPlay: 3440,
        freeScroll: false,
        wrapAround: true
    });
});

$(document).ready(function() {
    $('.ProductForm__Notify').on('click', function() {
        $('.notify__Form_container').slideToggle();
    })
});

$(document).on('click','.iwishBuyBtn',function(e){
  e.preventDefault();
  var form = $(this).closest('form');
  $(this).val('Adding...');
  $(this).addClass('prod_adding');
  var price = $(this).data('price');
  form.find('.err_msg').remove();
  var _this = $(this);
  $.ajax({
    method: "post",
    url: "/cart/add.js",
    data: form.serialize(),
    dataType: "json",
    success: function(data){
      console.log(data);
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: form.find('[name=id]').val(),
          quantity: parseInt(form.find('[name="quantity"]').val())
        }
      }))
      _this.removeClass('prod_adding');
      _this.addClass('prod_addded');
	  _this.val('Add to cart');
      setTimeout(function(e){
        _this.removeClass('prod_addded');
      },2000)
    },
    error: function(err){
      var err_msg = err.responseJSON.description
      form.append('<p class="err_msg">'+err_msg+'</p>');
      _this.val('Add to cart');
      _this.removeClass('prod_addded prod_adding');
      setTimeout(function(e){
        form.find('.err_msg').remove();
      },2000)
    }
  })
 return false;
})

$(window).on('load',function(e){
  $('.iwishBuyBtn.disabled').val('Sold Out');
})

$(document).ready(function() {
  $('.size_chart, .sizechart__close').on('click', function() {
    $('#size_chart').slideToggle();
    $('#size_chart').toggleClass('active');
    $('body').toggleClass('sizechart__active');
  });
});

$(document).ready(function() {
  $('.find_size, .sizechart__close1').on('click', function() {
    $('#find_chart').slideToggle();
    $('#find_chart').toggleClass('active');
    $('body').toggleClass('sizechart__active');
  });
});

$(document).on('click','.cart-notes-cover .note-cancel',function(e){
  $(this).closest('.Cart__OffscreenNoteContainer').attr('aria-hidden',true);
  $(this).closest('.sidebar-cart-slide').removeClass('has-note-open');
});
$(document).on('click','.ctm_meter_plus',function(e){
  if($(this).closest('.CartItem__QuantitySelector').length != 0){
    $(this).closest('.CartItem__QuantitySelector').find('.meter_trigger .ctm_main_plus')[0].click();
  }
})

$(document).on('click','.ctm_meter_minus',function(e){
  if($(this).closest('.CartItem__QuantitySelector').length != 0){
    $(this).closest('.CartItem__QuantitySelector').find('.meter_trigger .ctm_main_minus')[0].click();
  }
})

$(".wishlist-close").click(function(){
  $(".wislist-notification").hide();
});
$('.add_cart_btn .SizeSwatchList li :radio').on('change',function(e){
  var id = $(this).data('id');
  $(this).closest('form').find('[name="id"]').val(id);
})
 $('.ctm_extra_add_to_cart').on('click',function(e){
        var form = $(this).closest('form');
        $(this).text('Adding...');
        $(this).addClass('prod_adding');
        form.find('.err_msg').remove();
        var _this = $(this);
        $.ajax({
          method: "post",
          url: "/cart/add.js",
          data: form.serialize(),
          dataType: "json",
          success: function(data){
            console.log(data);
            document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: form.find('[name=id]').val(),
                quantity: parseInt(form.find('[name="quantity"]').val())
              }
            }))
              _this.text('Add To Cart');
          },
          error: function(err){
            var err_msg = err.responseJSON.description
            form.append('<p class="err_msg">'+err_msg+'</p>');
            setTimeout(function(e){
              form.find('.err_msg').remove();
            },2000)
          }
        })

      })

$(document).on('click', '[data-action="view-cart"]', function() {
  var event = new CustomEvent('click', {
    bubbles: true,
    cancelable: true
  });
  var targetElement = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
  targetElement.dispatchEvent(event);

  window.addedVariants = [];

  if (!$(this).siblings('#cntl-back-in-stock button').length) {
    $(this).siblings('[data-action="add-to-cart"]').show();
  }
  $('[data-action="view-cart"]').remove();
});


$(".offer_section-toggle").click(function(){
  $(".offersSection").slideToggle();
});



 $("body").on('mouseover','.offer_coupon',function(e){
        $(this).prev().show();
        $(this).prev().html('copy');  
      });
      $("body").on('mouseout','.offer_coupon',function(){
        $(this).prev().hide();
      });
      $("body").on("click",".offer_coupon", function(){
        var copyText = undefined;
        copyText = $(this).find("strong").text();
        navigator.clipboard.writeText(copyText);

        $(this).prev().html('');
        $(this).prev().html('copied');

        setTimeout(function(){ 
          $('span.hover').fadeOut("slow");
          $(this).prev().html('copy');  
        }, 500);
      });




/*$('.HorizontalList__Item.desktop-currency a').on('click',function(e) {
   e.preventDefault();
   $(this).closest('.HorizontalList__Item').find('.desktop-currency-hover').toggleClass('open'); 
   return false;  
})*/

$('.second-header .HorizontalList__Item').hover(function(e) {
  $(this).addClass('is-expended').find('.MegaMenu').attr('aria-hidden',false);  
  $(this).find('.DropdownMenu').attr('aria-hidden',false);  
},function(e) {
  $(this).removeClass('is-expended').find('.MegaMenu').attr('aria-hidden',true);  
  $(this).find('.DropdownMenu').attr('aria-hidden',true);  
})

$(document).on('click', '.offer_section-toggle', function(e) {
    $(".offer_section-toggle").removeClass("offer_section_active");
    $(".offersSection").slideUp();
    if (!$(this).next().is(":visible")) {
        $(this).next().slideDown();
        $(this).addClass("offer_section_active");
    }
})


$(window).scroll(function(){
    if ($(window).scrollTop() >= 20) {
        $('body').addClass('fixed-header-logo');
    }
    else {
        $('body').removeClass('fixed-header-logo');
    }
});


$(window).on("scroll", () => {
  $(".CollectionInner").each(function() {
    //var className = $(this).attr("touching")
    var offset = $(this).offset().top - $(window).scrollTop() ;
    if (offset <= 0) {
      $('body').addClass('ctm_size_filter-hide')
    } else {
      $('body').removeClass('ctm_size_filter-hide')
    }
  })
}).trigger("scroll")



// $(document).ready(function(){
//     if($(window).width() < 798){
//         var currTimer = setInterval(function(){
//             if($(".bacurr-cur-block select").length){
//             clearInterval(currTimer);
//                 $(".mobile-currency-append").append($(".bacurr-cur-block"));
//             }
//         },500);
//     }
// })

